import { render, staticRenderFns } from "./PersonalContact.vue?vue&type=template&id=77396e3c&"
import script from "./PersonalContact.vue?vue&type=script&lang=js&"
export * from "./PersonalContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports